import { formatBonuses } from "../libs/format";
import type { ActivityScans, ScanCustomer } from "../modules/scans/api";
import { cn } from "../libs/cn";
import { Icon } from "./ui/icons";

// Клиент консультации — по отсканированной карте или введённому телефону. Что показать в две строки.
export function customerLines(customer: ScanCustomer) {
  const details = [
    customer.cardMasked && `карта ${customer.cardMasked}`,
    customer.bonuses !== undefined && formatBonuses(customer.bonuses),
  ].filter(Boolean) as string[];
  if (customer.name) {
    return { title: customer.name, subtitle: details.join(" · ") || customer.phoneMasked || "" };
  }
  return {
    title: customer.phoneMasked ?? "Клиент",
    subtitle: customer.found ? details.join(" · ") : "карта не найдена · новый клиент",
  };
}

// Подпись-счётчик, как попросил заказчик: «Изделий · 3».
export const itemsLabel = (count: number) => `Изделий · ${count}`;

// Карточка клиента на залитом цветом экране консультации.
export function CustomerCard({ customer, inverse }: { customer: ScanCustomer; inverse?: boolean }) {
  const { title, subtitle } = customerLines(customer);
  return (
    <div
      className={cn(
        "flex max-w-full items-center gap-3 rounded-2xl px-4 py-2.5",
        inverse ? "bg-white/15 ring-1 ring-white/30" : "bg-[var(--color-surface)]",
      )}
    >
      <Icon
        name={customer.name ? "user" : "phone"}
        className={cn("size-6 shrink-0", inverse ? "opacity-90" : "text-[var(--color-muted)]")}
      />
      <span className="flex min-w-0 flex-col leading-tight">
        <span className="truncate font-semibold">{title}</span>
        {subtitle && (
          <span className={cn("text-sm", inverse ? "opacity-85" : "text-[var(--color-muted)]")}>{subtitle}</span>
        )}
      </span>
    </div>
  );
}

// Блок «Уже отмечено» на финише: клиент и просмотренные изделия — без ручного ввода.
export function ScansSummary({ scans }: { scans: ActivityScans }) {
  const { customer, items } = scans;
  return (
    <>
      {customer && <CustomerCard customer={customer} />}
      {items.length > 0 && (
        <div className="flex flex-col rounded-xl bg-[var(--color-surface)] px-3 py-2 leading-tight">
          <span className="font-semibold">{itemsLabel(items.length)}</span>
          <span className="line-clamp-2 text-sm text-[var(--color-muted)]">
            {items.map((item) => item.title).join(" · ")}
          </span>
        </div>
      )}
    </>
  );
}
